import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SanctuaryHero() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="sanctuary-hero" ref={sectionRef} className="relative w-full overflow-hidden bg-linear-to-br from-[var(--color-background)] via-[var(--color-background)] to-[var(--color-secondary)]/30 py-16 lg:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div className={`relative order-2 lg:order-1 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl shadow-2xl shadow-[var(--color-shadow)]/10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573125/img/minimalist_living_room_hero.png" alt="A calm, minimalist living room with organized shelving and soft lighting" className="h-full w-full object-cover object-center transition-transform duration-700 hover:scale-105" />
              {}
              <div className="absolute inset-0 bg-linear-to-t from-black/10 to-transparent pointer-events-none" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 -z-10 h-64 w-64 rounded-full bg-[var(--color-secondary)]/50 blur-3xl" />
          </div>

          {}
          <div className={`flex flex-col justify-center order-1 lg:order-2 transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <h1 className="font-serif text-5xl font-medium leading-[1.1] tracking-tight text-[var(--color-foreground)] sm:text-6xl lg:text-7xl">
              Create a Calm, <br />
              <span className="italic text-[var(--color-chart-1)]">Organized</span> Home.
            </h1>
            
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-[var(--color-muted-foreground)] sm:text-xl">
              Simple organization ideas, decluttering guides, and smart storage
              solutions for everyday living. Transform your space into a
              sanctuary.
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
              <Button asChild size="lg" className="bg-[var(--color-chart-1)] text-white hover:bg-[var(--color-chart-1)]/90 shadow-lg shadow-[var(--color-chart-1)]/20 rounded-full px-8 h-14 text-lg">
                <Link to="/ToolkitPage">
                  Start Organizing
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-12 flex items-center gap-4 text-sm text-[var(--color-muted-foreground)]">
              <div className="flex -space-x-3">
                {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-10 w-10 rounded-full border-2 border-[var(--color-background)] bg-[var(--color-secondary)]" />)}
              </div>
              <p>Join 10,000+ happy organizers</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}